module.exports = __webpack_public_path__ + "img/boolflix-ok.247d1add.png";